import { render, staticRenderFns } from "./BulkInsertUpdateIssues.vue?vue&type=template&id=003374d1&scoped=true&"
import script from "./BulkInsertUpdateIssues.vue?vue&type=script&lang=js&"
export * from "./BulkInsertUpdateIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003374d1",
  null
  
)

export default component.exports